import { useEffect, useState, MouseEvent, ReactElement } from 'react';
import session from '../Services/Session';
import { generatePath, useLocation } from 'react-router';
import { BottomNavigation, BottomNavigationAction, Container } from '@mui/material';
import EventList from './EventList';
import { Link } from 'react-router-dom';
import Settings from './Settings';
import { PageHostContext } from '../Hooks/PageHostContext';
import { IPage, Page } from '../Components/Page';
import TicketSearch from './TicketSearch';
import EventQuickStats from './EventQuickStats';
import { ReactComponent as StatsIcon } from '../Images/sat.svg';
import useAppBar from '../Hooks/AppBarContext';
import AspectRatioIcon from '@mui/icons-material/AspectRatio';
import { appSettings } from '../AppSettings';
import { useActions } from '../Hooks/Actions';
import "./Home.scss"

interface IHomeProps {

    content: IPage;
}


export default function Home(props: IHomeProps) {

    const actions = useActions();

    const location = useLocation();

    const [page, setPage] = useState(props.content);

    const [quickStatsAnchor, setQuickStatsAnchor] = useState(null as HTMLElement);

    const [quickStatsTimer, setQuickStatsTimer] = useState<number>(null);

    const appBar = useAppBar();



    useEffect(() => {

        if (!session.isValid())
            actions.login();
        else {
            if (page?.appBar)
                appBar(page.appBar);

        }
    }, []);

    const pages = [TicketSearch, EventList, Settings];

    if (!page)
        setPage(pages.find(a => a.route === location.pathname));

    const onStatsClick = (ev: MouseEvent) => {
    
        setQuickStatsAnchor(ev.currentTarget as HTMLElement);

        if (quickStatsTimer)
            clearTimeout(quickStatsTimer);

        if (appSettings.quickStatsTimeout) {
            setQuickStatsTimer(setTimeout(() => {

                setQuickStatsAnchor(null);

            }, appSettings.quickStatsTimeout) as any);
        }
    }

    const onConsoleClick = () => {
        const obj = document.getElementById("console");
        if (obj.classList.contains("visible"))
            obj.classList.remove("visible");
        else
            obj.classList.add("visible");
    }

    const buttons: ReactElement[] = [];

    const addButton = (a: IPage) => {
        if (!a.isEnabled || a.isEnabled()) {
            buttons.push(<BottomNavigationAction
                key={a.name}
                component={Link}
                to={generatePath(a.route, { eventId: session.activeEvent?.id, gateId: session.activeGate?.code })}
                label={a.title}
                value={a.name}
                icon={a.icon}
            />)
        }
    }

    addButton(pages[1]);

    if (session.activeEvent != null && session.activeGate != null) 
        buttons.push(<BottomNavigationAction key="stats" value="-" label="Stats" icon={<StatsIcon />} onClick={onStatsClick} />);

    addButton(pages[0]);
    addButton(pages[2]);


    if (appSettings.debugMode)
        buttons.push(<BottomNavigationAction key="console" value="-" label="Console" icon={<AspectRatioIcon />} onClick={onConsoleClick} />);


    return (
        <PageHostContext.Provider value={{ setPage }}>
            <div className="home">
                <Container className="content">
                    <Page container={Home} value={page} />
                </Container>
                {!appSettings.hideMenu && <BottomNavigation showLabels value={page.name} onChange={(_, newValue) => {
                    if (newValue != "-")
                        setPage(pages.find(a => a.name === newValue));
                }}>
                    {buttons}
                </BottomNavigation>
                }
                <EventQuickStats origin="top" anchor={quickStatsAnchor} onClose={() => setQuickStatsAnchor(null)} />
            </div>
        </PageHostContext.Provider>
    );
}